import React, {Component} from 'react';
import ReactDOM from "react-dom";
import FaqAccordionItem from "./FaqAccordionItem";

export default class FaqAccordion extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        const style = {
            paddingBottom: '60px'
        };
        return (
            <React.Fragment>
                {this.props.sections.map((section, index) => {
                    return (
                        <React.Fragment key={index}>
                            <div className="row text-center justify-content-center commercial-row" style={style}>
                                <div className="col-md-12">
                                    <h2 className="commercial-heading">{section.title}</h2>
                                    <hr className="accreditations-divider"/>
                                </div>
                            </div>
                            {section.questions.map((question, i) => {
                                return (
                                    <FaqAccordionItem key={i} question={question}/>
                                )
                            })}
                        </React.Fragment>
                    )
                })}
            </React.Fragment>
        );
    }
}

if (document.getElementById('faqAccordion')) {
    let element = document.getElementById('faqAccordion');
    ReactDOM.render(<FaqAccordion sections={JSON.parse(element.dataset.sections)}/>, element);
}

